import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Senderid = ()=>{
    const [senderid, setSenderid] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`senderId?page=${page}`);
            console.log(data);
            setSenderid(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);



    
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`senderid/${id}`);
            setSenderid(senderid.filter((senderid) => senderid.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Senderid'}>
            <InnerNav createLink={'/senderidCreate'} listLink={'/senderid'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Client </th>
                                    <th className="px-4 py-3">Name </th>
                                    <th className="px-4 py-3">Sendertype </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {senderid.map((senderid)=>{
                                         return(
                                             <tr key={senderid.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{senderid.id}</td>
                                                 <td className="px-4 py-3 text-sm">{senderid.client.name}</td>
                                                 <td className="px-4 py-3 text-sm">{senderid.name}</td>
                                                 <td className="px-4 py-3 text-sm">{senderid.sender_type.sender_type}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/senderid/${senderid.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(senderid.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Senderid;